import { render, staticRenderFns } from "./CompleteRepair.vue?vue&type=template&id=36863c2f&"
import script from "./CompleteRepair.vue?vue&type=script&lang=js&"
export * from "./CompleteRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports